// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"vehicle-image_imageContainer__O8FsR","image":"vehicle-image_image__yLlQb"};